export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0074.dde9b1d.webp";